import { createContext, use } from "react";
import { defined } from "@entrilia/shared/utilities/typeHelper";
import type { Metric } from "../../../../api/types/portfolioMonitoringTypes";

export interface Props {
  hasEditPermissions: boolean;
  metrics: Metric[];
  onEditMetric: (metric: Metric) => void;
  onDeleteMetric: (metric: Metric) => void;
  onDeactivateMetric: (metric: Metric) => void;
}

export const MetricsPageContext = createContext<Props | undefined>(undefined);

export const useMetricsPageContext = () =>
  defined(use(MetricsPageContext), "Attempt to use MetricsPageContext without provider");
